import {
  ReactPlugin,
  withAITracking,
} from "@microsoft/applicationinsights-react-js";

/* MODULE IMPORTS */
import React, { Component } from "react";

var reactPlugin = new ReactPlugin();

export class ColunaEsquerda extends Component {
  static displayName = ColunaEsquerda.name;

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="coluna-esquerda-wrapper">
        <div className="lista-nome-top">{this.props.name}</div>
        <div className="lista-foto-container">
          <img
            src={this.props.photoUrl || require("../../images/user.svg")}
            alt={this.props.name}
            className="lista-foto-centralizada"
          />
        </div>
      </div>
    );
  }
}

export default withAITracking(reactPlugin, ColunaEsquerda);
